var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('h1',[_vm._v("Task Map")]),_c('p',[_vm._v("Shows the location of approved tasks. There are currently "+_vm._s(this.addresses.length)+" ongoing tasks.")]),(!_vm.loading)?_c('AddressMap',{attrs:{"addresses":_vm.addresses,"center":_vm.getCenterLatLong()}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }